"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _noop2 = _interopRequireDefault(require("lodash/noop"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getInputValue = _interopRequireDefault(require("./get-input-value"));
var _validators = require("./validators");
var _excluded = ["input"],
  _excluded2 = ["input"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable complexity */
var VALIDATION_RESULT_KEYS = ['error', 'errorDetails', 'errorMessage'];

/**
 * A wrapping component for managing field state and form submission.
 * `FormContainer` creates no UI, but passes it's props on to its child, which
 * is typically a form element. It receives a `fields` configuration prop, and decorates it as
 * `fieldsState`. Each field gains dynamic `error`, `wasChanged`, and `wasValid` properties.
 * A nested `input` object maintains properties for the field's associated `input`.
 * i.e. `id`, `name`, `required`, `value`, `onChange`, `onBlur`.
 * Every change event in the child `form` triggers a re-render with updated field
 * state (including validation).
 */
var FormContainer = exports["default"] = /*#__PURE__*/function (_Component) {
  function FormContainer(props) {
    var _this;
    _classCallCheck(this, FormContainer);
    _this = _callSuper(this, FormContainer);
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      fields: _this.buildFieldsState(props)
    };
    return _this;
  }

  // eslint-disable-next-line camelcase
  _inherits(FormContainer, _Component);
  return _createClass(FormContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Wrap any new fields that are added
      var newFieldsState = this.buildFieldsState(nextProps);
      this.setState(function (previousState) {
        return {
          fields: Object.assign({}, newFieldsState, previousState.fields)
        };
      });
    }
  }, {
    key: "buildFieldsState",
    value: function buildFieldsState(props) {
      var _this2 = this;
      return Object.keys(props.fields).reduce(function (accumulator, fieldName) {
        var _field$input$value, _field$input;
        var field = props.fields[fieldName];
        var fieldObject = {
          id: fieldName,
          name: fieldName,
          onBlur: _this2.handleBlur,
          onChange: _this2.handleChange,
          value: _this2.formatFieldValue((_field$input$value = field === null || field === void 0 || (_field$input = field.input) === null || _field$input === void 0 ? void 0 : _field$input.value) !== null && _field$input$value !== void 0 ? _field$input$value : '', field.formatter),
          required: field.required !== false
        };
        if (field.input && field.input.hasOwnProperty('checked')) {
          fieldObject.checked = field.input.checked;
        }
        var validation = _this2.validateField(fieldObject, props.fields);
        accumulator[fieldName] = _objectSpread({
          input: fieldObject,
          formatter: field.formatter
        }, validation);
        return accumulator;
      }, {});
    }
  }, {
    key: "formatFieldValue",
    value: function formatFieldValue(value, formatter) {
      if (typeof formatter === 'function') {
        return formatter(value);
      }
      return value;
    }
  }, {
    key: "validateField",
    value: function validateField(fieldUpdate) {
      var _fields$fieldUpdate$n, _this$state$fields, _this$state;
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.fields;
      var field = (_fields$fieldUpdate$n = fields[fieldUpdate.name]) !== null && _fields$fieldUpdate$n !== void 0 ? _fields$fieldUpdate$n : {};
      var fieldsState = (_this$state$fields = this === null || this === void 0 || (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.fields) !== null && _this$state$fields !== void 0 ? _this$state$fields : {};
      var validator = field.validator || (field.required === false ? _noop2["default"] : _validators.validateExistence);
      var validationResult = validator(fieldUpdate, fieldsState);
      return (0, _pick2["default"])(validationResult, VALIDATION_RESULT_KEYS);
    }
  }, {
    key: "getDerivedFields",
    value: function getDerivedFields() {
      var activeFields = this.getActiveFields();
      var invalidFields = this.getInvalidFields(activeFields);
      var isValid = Object.keys(invalidFields).length === 0;
      return {
        activeFields: activeFields,
        invalidFields: invalidFields,
        isValid: isValid
      };
    }
  }, {
    key: "getFieldValues",
    value: function getFieldValues(fields) {
      return Object.keys(fields).reduce(function (accumulator, fieldName) {
        var fieldData = fields[fieldName].input;
        var fieldValue = fieldData.hasOwnProperty('checked') ? fieldData.checked : fieldData.value;
        accumulator[fieldName] = fieldValue;
        return accumulator;
      }, {});
    }
  }, {
    key: "getActiveFields",
    value: function getActiveFields() {
      var _this3 = this;
      // Filter field state to only display currently active fields (as defined by props).
      return Object.keys(this.props.fields).reduce(function (accumulator, fieldName) {
        accumulator[fieldName] = _this3.state.fields[fieldName];
        return accumulator;
      }, {});
    }
  }, {
    key: "getInvalidFields",
    value: function getInvalidFields(fieldState) {
      return Object.keys(fieldState).reduce(function (accumulator, fieldName) {
        if (fieldState[fieldName].error) {
          accumulator[fieldName] = (0, _pick2["default"])(fieldState[fieldName], VALIDATION_RESULT_KEYS);
        }
        return accumulator;
      }, {});
    }
  }, {
    key: "setFieldsState",
    value: function setFieldsState(resolver) {
      var _this4 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noop2["default"];
      var cachedPreviousState = this.state;
      this.setState(function (previousState) {
        var newFieldsState = resolver(previousState);
        return {
          fields: newFieldsState
        };
      }, function () {
        _this4.props.onFieldsStateChange(_this4.state, cachedPreviousState);
        callback();
      });
    }

    /**
     * Updates field with a new state object, useful for updating fields based on
     * server-side validation or nonstandard behavior.
     * @param {object} fieldUpdate - Field object matching shape of field objects
     * passed to `FormContainer` children.
     * @returns {void}
     */
  }, {
    key: "updateField",
    value: function updateField(fieldUpdate) {
      var fieldName = fieldUpdate.input.name;
      this.setFieldsState(function (previousState) {
        var previousField = previousState.fields[fieldName];
        var previousInput = previousField.input,
          previousProps = _objectWithoutProperties(previousField, _excluded);
        var currentInput = fieldUpdate.input,
          currentProps = _objectWithoutProperties(fieldUpdate, _excluded2);
        var updatedField = Object.assign({}, previousState.fields, _defineProperty({}, fieldName, _objectSpread(_objectSpread(_objectSpread({}, previousProps), currentProps), {}, {
          input: _objectSpread(_objectSpread({}, previousInput), currentInput)
        })));
        return updatedField;
      });
    }
  }, {
    key: "buildFieldUpdate",
    value: function buildFieldUpdate(fieldValue, event) {
      var _this$props$fields$fi;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var field = (_this$props$fields$fi = this.props.fields[fieldValue.name]) !== null && _this$props$fields$fi !== void 0 ? _this$props$fields$fi : {};
      var formattedValue = _objectSpread(_objectSpread({}, fieldValue), {}, {
        value: this.formatFieldValue(fieldValue.value, field.formatter)
      });
      var validation = this.validateField(formattedValue);
      var fieldUpdate = _objectSpread({
        input: formattedValue,
        formatter: field.formatter
      }, validation);
      if (!(validation !== null && validation !== void 0 && validation.error)) {
        fieldUpdate.wasValid = true;
      }
      if (options.eventType === 'blur') {
        fieldUpdate.wasBlurred = true;
      } else if (options.eventType === 'change') {
        var _event$target, _formattedValue$value;
        fieldUpdate.wasChanged = true;
        var fieldMaxLength = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.maxLength;
        var currentFieldValueLength = formattedValue === null || formattedValue === void 0 || (_formattedValue$value = formattedValue.value) === null || _formattedValue$value === void 0 ? void 0 : _formattedValue$value.length;
        if (fieldMaxLength > 0 && currentFieldValueLength === fieldMaxLength) {
          fieldUpdate.wasBlurred = true;
        }
      }
      return fieldUpdate;
    }
  }, {
    key: "handleFieldUpdateFromEvent",
    value: function handleFieldUpdateFromEvent(event, options) {
      var fieldsState = this.state.fields;
      var fieldName = event.target.name;
      var fieldValue = (0, _getInputValue["default"])(event);
      var fieldUpdate = this.buildFieldUpdate(fieldValue, event, options);

      // clear server side errors on change, as we can't know
      // until user re-submits that updated value will still
      // produce an error
      if (options.eventType === 'change') {
        var changedFieldCurrentState = fieldsState[fieldName];
        var hasServerSideError = changedFieldCurrentState.hasServerSideError;
        if (hasServerSideError) {
          fieldUpdate.hasServerSideError = false;
          // also clear any error message which would have been set by server error
          // NOTE: errorMessages for client errors are generated by Fields,
          // and not managed in the FormContainer field state
          fieldUpdate.errorMessage = '';
        }
      }

      // If the fieldUpdate doesn't have a name, we can't do anything
      // with it and should ignore it. This is likely the result of
      // a field event bubbling from a child element incorrectly.
      if (!fieldUpdate.input.name) {
        return;
      }
      this.props.onFieldUpdateFromEvent(event, fieldUpdate);
      this.updateField(fieldUpdate);
    }
  }, {
    key: "checkFields",
    value: function checkFields(event) {
      var _this5 = this;
      var getNewFieldsState = function getNewFieldsState(previousState) {
        return Object.keys(_this5.props.fields).reduce(function (accumulator, field) {
          var fieldData = previousState.fields[field] || {};
          var fieldValue = fieldData.input || {
            name: field,
            value: ''
          };
          accumulator[field] = _this5.buildFieldUpdate(fieldValue, event, {
            eventType: 'blur'
          });
          return accumulator;
        }, {});
      };
      var callback = function callback() {
        var _this5$props = _this5.props,
          focusOnSubmitError = _this5$props.focusOnSubmitError,
          onError = _this5$props.onError,
          onSubmit = _this5$props.onSubmit,
          focusOnInvalidAfterAnimation = _this5$props.focusOnInvalidAfterAnimation;
        var _this5$getDerivedFiel = _this5.getDerivedFields(),
          activeFields = _this5$getDerivedFiel.activeFields,
          invalidFields = _this5$getDerivedFiel.invalidFields,
          isValid = _this5$getDerivedFiel.isValid;
        var formData = _this5.getFieldValues(activeFields);
        var invalidFieldNames = Object.keys(invalidFields);
        if (!isValid && focusOnSubmitError) {
          focusOnInvalidAfterAnimation ? window.requestAnimationFrame(function () {
            return _this5.focusOnFirstInvalid(invalidFieldNames);
          }) : _this5.focusOnFirstInvalid(invalidFieldNames);
        }
        isValid ? onSubmit(formData) : onError(invalidFields);
      };
      this.setFieldsState(getNewFieldsState, callback);
    }
  }, {
    key: "handleChange",
    value: function handleChange(ev) {
      this.handleFieldUpdateFromEvent(ev, {
        eventType: 'change'
      });
    }
  }, {
    key: "focusOnFirstInvalid",
    value: function focusOnFirstInvalid(fieldNames) {
      var elContainer = this.containerRef.current;
      var elFirstInvalid = elContainer.querySelector(fieldNames.map(function (name) {
        return "#".concat(name);
      }).join(','));
      if (elFirstInvalid) {
        elFirstInvalid.focus();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(ev) {
      var _ev$target = ev.target,
        type = _ev$target.type,
        value = _ev$target.value;

      // Ignore blur events on radio and checkbox inputs, because change is all that
      // matters there. Also ignore blur events on elements with no `value`, as these
      // are not inputs but are children with events that bubbled.
      if (value === undefined || type === 'radio' || type === 'checkbox') {
        return;
      }
      this.handleFieldUpdateFromEvent(ev, {
        eventType: 'blur'
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(ev) {
      ev.preventDefault();
      this.checkFields(ev);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getDerivedField = this.getDerivedFields(),
        activeFields = _this$getDerivedField.activeFields,
        isValid = _this$getDerivedField.isValid;
      return /*#__PURE__*/(0, _react.cloneElement)(this.props.children, {
        ref: this.containerRef,
        isValid: isValid,
        fields: _objectSpread({}, activeFields),
        onSubmit: this.handleSubmit
      });
    }
  }]);
}(_react.Component);
_defineProperty(FormContainer, "defaultProps", {
  children: /*#__PURE__*/_react["default"].createElement("div", null),
  fields: {
    formatter: _noop2["default"]
  },
  focusOnInvalidAfterAnimation: true,
  focusOnSubmitError: true,
  onError: _noop2["default"],
  onFieldsStateChange: _noop2["default"],
  onFieldUpdateFromEvent: _noop2["default"],
  onSubmit: _noop2["default"]
});
FormContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  /**
   * An object to configure fields using input `names` as the key.
   *
   * Validation can specified for each field in the following ways:
   *
   * - `required: true` (default) uses the `validateExistence` as validator
   * - `required: false` no validation
   * - `validator` A custom validator function
   */
  fields: _propTypes["default"].shape({
    required: _propTypes["default"].bool,
    validator: _propTypes["default"].func,
    formatter: _propTypes["default"].func,
    input: _propTypes["default"].object
  }),
  /**
   * Set focus on the first invalid input during submittals.
   */
  focusOnSubmitError: _propTypes["default"].bool,
  /**
   * Callback for invalid form submittals. Invoked with validation results for invalid fields.
   */
  onError: _propTypes["default"].func.isRequired,
  /**
   * Callback for when the field state has changed. Invoked with `fieldsState`, `oldFieldsState`
   */
  onFieldsStateChange: _propTypes["default"].func.isRequired,
  /**
   * Callback for a when field has been updated from a dom event.
   * Invoked with the `event`, `fieldState`.
   */
  onFieldUpdateFromEvent: _propTypes["default"].func.isRequired,
  /**
   * Callback for valid form submittals. Invoked with form data.
   */
  onSubmit: _propTypes["default"].func.isRequired,
  /**
   * Forces `focusOnFirstInvalid` to wait for animations so that focus can be properly applied.
   */
  focusOnInvalidAfterAnimation: _propTypes["default"].bool
} : {};